import { useState, useEffect } from 'react';
import { getContasPagar, getContasReceber } from '../services/api';
import { PageHeader, Loading, Erro, Badge } from '../components/UI';
import FiltroData from '../components/FiltroData';
import './Financeiro.css';

const fmt    = v => v != null ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—';
const fmtDt  = v => v ? String(v).split('T')[0] : '—';

// ─── Aba: Contas a Pagar ──────────────────────────────────────────────────────

function TabPagar() {
  const [periodo, setPeriodo] = useState(null);
  const [status,  setStatus]  = useState('');
  const [busca,   setBusca]   = useState('');
  const [dados,   setDados]   = useState([]);
  const [load,    setLoad]    = useState(false);
  const [erro,    setErro]    = useState('');

  useEffect(() => {
    if (!periodo?.di) return;
    setLoad(true); setErro('');
    getContasPagar(periodo.di, periodo.df, status)
      .then(setDados)
      .catch(e => setErro(e.message))
      .finally(() => setLoad(false));
  }, [periodo?.di, periodo?.df, status]);

  const filtrados = busca
    ? dados.filter(r => (r.FORNECEDOR || '').toLowerCase().includes(busca.toLowerCase()))
    : dados;

  const total    = filtrados.reduce((s, r) => s + (parseFloat(r.TOTAL)      || 0), 0);
  const totalPago= filtrados.reduce((s, r) => s + (parseFloat(r.VALOR_PAGO) || 0), 0);

  return (
    <div>
      <div className="fin-filtros">
        <FiltroData onChange={setPeriodo} defaultModo="mes" />
        <select className="fin-select" value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">Todos</option>
          <option value="0">Aberto</option>
          <option value="1">Pago</option>
        </select>
        <input
          className="fin-busca"
          type="search"
          placeholder="Buscar fornecedor..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
        />
      </div>

      {periodo?.label && (
        <div className="fin-subtitulo">Vencimento: {periodo.label}</div>
      )}

      {erro && <Erro mensagem={erro} onRetry={() => {}} />}
      {load ? <Loading /> : (
        <>
          {filtrados.length > 0 && (
            <div className="fin-resumo">
              <div className="fin-resumo-item">
                <span>Total cobrado</span>
                <strong>{fmt(total)}</strong>
              </div>
              <div className="fin-resumo-item">
                <span>Total pago</span>
                <strong className="fin-pago">{fmt(totalPago)}</strong>
              </div>
              <div className="fin-resumo-item">
                <span>Registros</span>
                <strong>{filtrados.length}</strong>
              </div>
            </div>
          )}

          <div className="fin-tbl-wrap">
            <table className="fin-tbl">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Fornecedor</th>
                  <th className="fin-right">Vencimento</th>
                  <th className="fin-right">Valor</th>
                  <th className="fin-right">Total</th>
                  <th className="fin-right">Pagamento</th>
                  <th className="fin-right">Valor Pago</th>
                  <th>Forma Pgto</th>
                  <th>Parcela</th>
                </tr>
              </thead>
              <tbody>
                {filtrados.length === 0 && (
                  <tr><td colSpan={10} className="fin-vazio">Nenhum registro encontrado.</td></tr>
                )}
                {filtrados.map((d, i) => (
                  <tr key={i}>
                    <td style={{color:'var(--text-dim)',fontSize:12}}>{d.ID}</td>
                    <td>
                      <Badge
                        valor={d.STATUS === 1 || d.STATUS === '1' ? 'Pago' : 'Aberto'}
                        tipo={d.STATUS === 1 || d.STATUS === '1' ? 'success' : 'warning'}
                      />
                    </td>
                    <td><strong>{d.FORNECEDOR || '—'}</strong></td>
                    <td className="fin-right">{fmtDt(d.DATA_VENCIMENTO)}</td>
                    <td className="fin-right">{fmt(d.VALOR)}</td>
                    <td className="fin-right fin-bold">{fmt(d.TOTAL)}</td>
                    <td className="fin-right fin-dim">{fmtDt(d.DATA_PAGAMENTO)}</td>
                    <td className="fin-right">{fmt(d.VALOR_PAGO)}</td>
                    <td>{d.FORMA_PAGAMENTO || '—'}</td>
                    <td style={{fontSize:12,color:'var(--text-dim)'}}>{d.NUM_PARCELA && d.NUM_PARCELAS ? `${d.NUM_PARCELA}/${d.NUM_PARCELAS}` : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

// ─── Aba: Contas a Receber ────────────────────────────────────────────────────

function TabReceber() {
  const [periodo, setPeriodo] = useState(null);
  const [status,  setStatus]  = useState('');
  const [busca,   setBusca]   = useState('');
  const [dados,   setDados]   = useState([]);
  const [load,    setLoad]    = useState(false);
  const [erro,    setErro]    = useState('');

  useEffect(() => {
    if (!periodo?.di) return;
    setLoad(true); setErro('');
    getContasReceber(periodo.di, periodo.df, status)
      .then(setDados)
      .catch(e => setErro(e.message))
      .finally(() => setLoad(false));
  }, [periodo?.di, periodo?.df, status]);

  const filtrados = busca
    ? dados.filter(r => (r.CLIENTE || '').toLowerCase().includes(busca.toLowerCase()))
    : dados;

  const total      = filtrados.reduce((s, r) => s + (parseFloat(r.VALOR)    || 0), 0);
  const totalReceb = filtrados.reduce((s, r) => s + (parseFloat(r.RECEBIDO) || 0), 0);

  return (
    <div>
      <div className="fin-filtros">
        <FiltroData onChange={setPeriodo} defaultModo="mes" />
        <select className="fin-select" value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">Todos</option>
          <option value="N">Aberto</option>
          <option value="S">Recebido</option>
        </select>
        <input
          className="fin-busca"
          type="search"
          placeholder="Buscar cliente..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
        />
      </div>

      {periodo?.label && (
        <div className="fin-subtitulo">Vencimento: {periodo.label}</div>
      )}

      {erro && <Erro mensagem={erro} onRetry={() => {}} />}
      {load ? <Loading /> : (
        <>
          {filtrados.length > 0 && (
            <div className="fin-resumo">
              <div className="fin-resumo-item">
                <span>Total a receber</span>
                <strong>{fmt(total)}</strong>
              </div>
              <div className="fin-resumo-item">
                <span>Total recebido</span>
                <strong className="fin-pago">{fmt(totalReceb)}</strong>
              </div>
              <div className="fin-resumo-item">
                <span>Registros</span>
                <strong>{filtrados.length}</strong>
              </div>
            </div>
          )}

          <div className="fin-tbl-wrap">
            <table className="fin-tbl">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Cliente</th>
                  <th>Doc</th>
                  <th>Parcela</th>
                  <th className="fin-right">Vencimento</th>
                  <th className="fin-right">Valor</th>
                  <th className="fin-right">Recebido em</th>
                  <th className="fin-right">Recebido</th>
                  <th>Forma Pgto</th>
                </tr>
              </thead>
              <tbody>
                {filtrados.length === 0 && (
                  <tr><td colSpan={10} className="fin-vazio">Nenhum registro encontrado.</td></tr>
                )}
                {filtrados.map((d, i) => (
                  <tr key={i}>
                    <td style={{color:'var(--text-dim)',fontSize:12}}>{d.ID}</td>
                    <td>
                      <Badge
                        valor={d.QUITADO === 'S' ? 'Recebido' : 'Aberto'}
                        tipo={d.QUITADO === 'S' ? 'success' : 'warning'}
                      />
                    </td>
                    <td><strong>{d.CLIENTE || '—'}</strong></td>
                    <td style={{fontSize:12,color:'var(--text-dim)'}}>{d.DOC || '—'}</td>
                    <td style={{fontSize:12,color:'var(--text-dim)'}}>{d.PARCELA || '—'}</td>
                    <td className="fin-right">{fmtDt(d.VENCIMENTO)}</td>
                    <td className="fin-right fin-bold">{fmt(d.VALOR)}</td>
                    <td className="fin-right fin-dim">{fmtDt(d.PAGOEM)}</td>
                    <td className="fin-right">{fmt(d.RECEBIDO)}</td>
                    <td>{d.FORMA_PAGAMENTO || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────

export default function Financeiro() {
  const [aba, setAba] = useState('pagar');

  return (
    <div>
      <PageHeader titulo="Financeiro" subtitulo="Contas a pagar e receber" />

      <div className="tabs-bar">
        <button className={`tab-btn${aba === 'pagar'   ? ' tab-btn--ativo' : ''}`} onClick={() => setAba('pagar')}>
          Contas a Pagar
        </button>
        <button className={`tab-btn${aba === 'receber' ? ' tab-btn--ativo' : ''}`} onClick={() => setAba('receber')}>
          Contas a Receber
        </button>
      </div>

      {aba === 'pagar'   && <TabPagar />}
      {aba === 'receber' && <TabReceber />}
    </div>
  );
}
